
// import React, { useState, useEffect } from 'react';
// import { database, auth } from '../firebase';
// import { ref, onValue, off } from 'firebase/database';
// import { onAuthStateChanged } from 'firebase/auth';
// import ReactDOMServer from 'react-dom/server';

// // Helper: Extract city from address
// const getCityFromAddress = (address) => {
//   if (!address) return 'Unknown City';
//   const addressParts = address.trim().split(/\s+/);
//   return addressParts.length > 0 ? addressParts[addressParts.length - 1] : 'Unknown City';
// };

// // Filter Section Component
// const FilterSection = ({ title, options, selected, onChange }) => {
//   const handleCheckboxChange = (option) => {
//     if (option === options[0]) { // "All" option
//       if (selected.includes(option)) {
//         onChange([]);
//       } else {
//         onChange([...options]);
//       }
//     } else {
//       const newSelected = selected.includes(option)
//         ? selected.filter(item => item !== option && item !== options[0])
//         : [...selected.filter(item => item !== options[0]), option];
      
//       if (newSelected.length === options.length - 1) {
//         onChange([options[0], ...newSelected]);
//       } else {
//         onChange(newSelected);
//       }
//     }
//   };

//   return (
//     <div style={{
//       backgroundColor: '#f8fafc',
//       padding: '16px',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//       boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
//       transition: 'all 0.3s ease',
//       maxWidth: '220px',
//       marginBottom: '16px',
//     }}>
//       <h2 style={{
//         fontSize: '16px',
//         fontWeight: '600',
//         color: '#1e293b',
//         marginBottom: '8px',
//         borderBottom: '2px solid #3b82f6',
//         paddingBottom: '6px',
//       }}>{title}</h2>
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//         {options.map((option) => (
//           <label key={option} style={{ 
//             display: 'flex', 
//             alignItems: 'center', 
//             gap: '8px',
//             cursor: 'pointer',
//             padding: '6px',
//             borderRadius: '6px',
//             transition: 'background-color 0.2s',
//             backgroundColor: selected.includes(option) ? '#eff6ff' : 'transparent',
//           }}
//           onMouseEnter={(e) => {
//             if (!selected.includes(option)) {
//               e.currentTarget.style.backgroundColor = '#f1f5f9';
//             }
//           }}
//           onMouseLeave={(e) => {
//             if (!selected.includes(option)) {
//               e.currentTarget.style.backgroundColor = 'transparent';
//             }
//           }}
//           >
//             <input
//               type="checkbox"
//               checked={selected.includes(option)}
//               onChange={() => handleCheckboxChange(option)}
//               style={{
//                 height: '14px',
//                 width: '14px',
//                 accentColor: '#3b82f6',
//                 cursor: 'pointer',
//               }}
//             />
//             <span style={{ 
//               fontSize: '14px',
//               color: '#475569',
//               userSelect: 'none',
//               fontWeight: selected.includes(option) ? '500' : '400',
//             }}>{option}</span>
//           </label>
//         ))}
//       </div>
//     </div>
//   );
// };

// // Purchase Outstanding Report Display Component
// const PurchaseOutstandingReportDisplay = ({ filters, branchProfile, invoicesData }) => {
//   const filteredInvoicesData = invoicesData.filter(item => {
//     let matchesFilters = true;
//     if (filters.supplier.length > 0 && !filters.supplier.includes("All Suppliers")) {
//       matchesFilters = matchesFilters && filters.supplier.includes(item.supplierDetails?.supplier || "Unknown Supplier");
//     }
//     if (filters.branch.length > 0 && !filters.branch.includes("All Branches")) {
//       matchesFilters = matchesFilters && filters.branch.includes(branchProfile.branchName || "Unknown Branch");
//     }
//     return matchesFilters;
//   });

//   const totalInvoiceAmount = filteredInvoicesData.reduce((sum, item) => sum + (parseFloat(item.summary?.netAmt || 0)), 0);
//   const totalPaidAmount = filteredInvoicesData.reduce((sum, item) => sum + (parseFloat(item.summary?.totalPaid || 0)), 0);
//   const totalAdjAmount = filteredInvoicesData.reduce((sum, item) => sum + (parseFloat(item.summary?.adjAmt || 0)), 0);
//   const totalBalanceAmount = filteredInvoicesData.reduce((sum, item) => sum + (parseFloat(item.summary?.netAmt || 0) - parseFloat(item.summary?.totalPaid || 0) - parseFloat(item.summary?.adjAmt || 0)), 0);

//   const city = branchProfile.city || getCityFromAddress(branchProfile.address);
//   const currentDate = new Date().toLocaleDateString('en-GB');

//   return (
//     <div style={{
//       backgroundColor: 'white',
//       padding: '30px',
//       marginTop: '20px',
//       border: '2px solid #3b82f6',
//       borderRadius: '12px',
//       fontFamily: 'Arial, sans-serif',
//       fontSize: '12px',
//       pageBreakInside: 'avoid',
//       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
//     }} className="print-only">
//       {/* Header */}
//       <div style={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'flex-start', 
//         marginBottom: '30px',
//         paddingBottom: '20px',
//         borderBottom: '2px solid #e2e8f0'
//       }}>
//         <div style={{ flex: 1 }}>
//           <h1 style={{ 
//             fontSize: '24px', 
//             fontWeight: 'bold', 
//             margin: '0', 
//             marginBottom: '15px',
//             color: '#1e293b',
//             textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
//           }}>
//             {branchProfile.branchName}
//           </h1>
//           <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#475569' }}>
//             <div style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '600', color: '#3b82f6' }}>
//               Purchase Outstanding Report
//             </div>
//             <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
//               <span><strong>As On:</strong> {currentDate}</span>
//               <span><strong>Suppliers:</strong> {filters.supplier.includes("All Suppliers") ? "All Suppliers" : filters.supplier.join(", ")}</span>
//             </div>
//           </div>
//         </div>
//         <div style={{
//           background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
//           color: 'white',
//           padding: '15px 25px',
//           borderRadius: '15px',
//           textAlign: 'center',
//           minWidth: '150px',
//           boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//         }}>
//           <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{city}</div>
//           <div style={{ fontSize: '12px', marginTop: '5px', opacity: '0.9' }}>
//             {filters.branch.includes("All Branches") ? "All Branches" : filters.branch.join(", ")}
//           </div>
//         </div>
//       </div>

//       {/* Outstanding Table */}
//       <div style={{ overflowX: 'auto' }}>
//         <table style={{ 
//           width: '100%', 
//           borderCollapse: 'collapse', 
//           fontSize: '11px', 
//           border: '2px solid #3b82f6',
//           borderRadius: '8px',
//           overflow: 'hidden',
//           boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//         }}>
//           <thead>
//             <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
//               <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
//               <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Inv No</th>
//               <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Inv Dt</th>
//               <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Inv Amt</th>
//               <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Paid Amt</th>
//               <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Adj Amt</th>
//               <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Outstanding</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredInvoicesData.length === 0 ? (
//               <tr>
//                 <td colSpan="7" style={{ 
//                   border: '1px solid #cbd5e1', 
//                   padding: '30px', 
//                   textAlign: 'center', 
//                   color: '#64748b', 
//                   fontStyle: 'italic',
//                   fontSize: '14px',
//                   backgroundColor: '#f8fafc'
//                 }}>
//                   No outstanding data found for the selected criteria
//                 </td>
//               </tr>
//             ) : (
//               filteredInvoicesData.map((item, index) => {
//                 const balance = parseFloat(item.summary?.netAmt || 0) - 
//                               parseFloat(item.summary?.totalPaid || 0) - 
//                               parseFloat(item.summary?.adjAmt || 0);
//                 return (
//                   <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.supplierDetails?.invoiceNo || 'N/A'}</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{item.supplierDetails?.invoiceDate || 'N/A'}</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{parseFloat(item.summary?.netAmt || 0).toFixed(2)}</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{parseFloat(item.summary?.totalPaid || 0).toFixed(2)}</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{parseFloat(item.summary?.adjAmt || 0).toFixed(2)}</td>
//                     <td style={{ 
//                       border: '1px solid #cbd5e1', 
//                       padding: '8px', 
//                       textAlign: 'right', 
//                       fontSize: '11px',
//                       color: balance > 0 ? '#dc2626' : '#16a34a'
//                     }}>₹{balance.toFixed(2)}</td>
//                   </tr>
//                 );
//               })
//             )}
            
//             {filteredInvoicesData.length > 0 && (
//               <tr style={{ backgroundColor: '#fef3c7', fontWeight: 'bold', borderTop: '2px solid #f59e0b' }}>
//                 <td colSpan="3" style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'center', fontSize: '12px', fontWeight: '600' }}>
//                   Grand Total
//                 </td>
//                 <td style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>₹{totalInvoiceAmount.toFixed(2)}</td>
//                 <td style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>₹{totalPaidAmount.toFixed(2)}</td>
//                 <td style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>₹{totalAdjAmount.toFixed(2)}</td>
//                 <td style={{ 
//                   border: '1px solid #cbd5e1', 
//                   padding: '10px', 
//                   textAlign: 'right', 
//                   fontSize: '12px', 
//                   fontWeight: '600',
//                   color: totalBalanceAmount > 0 ? '#dc2626' : '#16a34a'
//                 }}>₹{totalBalanceAmount.toFixed(2)}</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Summary Section */}
//       {filteredInvoicesData.length > 0 && (
//         <div style={{ 
//           marginTop: '30px', 
//           padding: '20px', 
//           backgroundColor: '#f8fafc', 
//           borderRadius: '8px',
//           border: '1px solid #e2e8f0'
//         }}>
//           <h3 style={{ 
//             fontSize: '16px', 
//             fontWeight: '600', 
//             marginBottom: '15px',
//             color: '#1e293b'
//           }}>Summary</h3>
//           <div style={{ 
//             display: 'grid', 
//             gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', 
//             gap: '15px'
//           }}>
//             <div style={{ textAlign: 'center' }}>
//               <div style={{ fontSize: '12px', color: '#64748b' }}>Total Invoices</div>
//               <div style={{ fontSize: '18px', fontWeight: '600', color: '#3b82f6' }}>{filteredInvoicesData.length}</div>
//             </div>
//             <div style={{ textAlign: 'center' }}>
//               <div style={{ fontSize: '12px', color: '#64748b' }}>Total Invoice Amount</div>
//               <div style={{ fontSize: '18px', fontWeight: '600', color: '#dc2626' }}>₹{totalInvoiceAmount.toFixed(2)}</div>
//             </div>
//             <div style={{ textAlign: 'center' }}>
//               <div style={{ fontSize: '12px', color: '#64748b' }}>Total Paid Amount</div>
//               <div style={{ fontSize: '18px', fontWeight: '600', color: '#059669' }}>₹{totalPaidAmount.toFixed(2)}</div>
//             </div>
//             <div style={{ textAlign: 'center' }}>
//               <div style={{ fontSize: '12px', color: '#64748b' }}>Net Balance</div>
//               <div style={{ fontSize: '18px', fontWeight: '600', color: '#7c3aed' }}>₹{totalBalanceAmount.toFixed(2)}</div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // Main Purchase Outstanding Report Generator Component
// const PurchaseOutstandingReportGenerator = () => {
//   const [filters, setFilters] = useState({
//     branch: ["All Branches"],
//     supplier: ["All Suppliers"]
//   });
//   const [branches, setBranches] = useState(["All Branches"]);
//   const [suppliers, setSuppliers] = useState(["All Suppliers"]);
//   const [currentUser, setCurrentUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [showReport, setShowReport] = useState(false);
//   const [branchProfile, setBranchProfile] = useState({
//     branchName: "SUPREME TRADERS",
//     address: "",
//     phone: "",
//     city: ""
//   });
//   const [invoicesData, setInvoicesData] = useState([]);

//   const encodeEmailForPath = (email) => {
//     return email.replace(/[.#$[\]]/g, '_');
//   };

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       setCurrentUser(user);
//       if (user) {
//         loadFirebaseData(user);
//       }
//       setLoading(false);
//     });
//     return () => unsubscribe();
//   }, []);

//   const loadFirebaseData = (user) => {
//     const encodedEmail = encodeEmailForPath(user.email);

//     const branchProfileRef = ref(database, `users/${encodedEmail}/branchProfiles`);
//     onValue(branchProfileRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const profiles = Object.values(data);
//         const latestProfile = profiles[profiles.length - 1];
//         setBranchProfile({
//           branchName: latestProfile.branchName || "SUPREME TRADERS",
//           address: `${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`.trim(),
//           phone: latestProfile.mobileNo || '',
//           city: latestProfile.city || getCityFromAddress(`${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`)
//         });
//         setBranches(["All Branches", latestProfile.branchName || "SUPREME TRADERS"]);
//       }
//     });

//     const suppliersRef = ref(database, `users/${encodedEmail}/suppliers`);
//     onValue(suppliersRef, (snapshot) => {
//       const suppliersData = ["All Suppliers"];
//       if (snapshot.exists()) {
//         snapshot.forEach((childSnapshot) => {
//           const supplier = childSnapshot.val();
//           if (supplier.supplierName && !suppliersData.includes(supplier.supplierName)) {
//             suppliersData.push(supplier.supplierName);
//           }
//         });
//       }
//       setSuppliers(suppliersData);
//     });

//     const invoicesRef = ref(database, `users/${encodedEmail}/invoices`);
//     onValue(invoicesRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const invoicesRecords = Object.entries(data).map(([id, invoice]) => ({
//           id,
//           supplierDetails: {
//             supplier: invoice.supplierDetails?.supplier || 'Unknown Supplier',
//             invoiceNo: invoice.supplierDetails?.invoiceNo || '',
//             invoiceDate: invoice.supplierDetails?.invoiceDate || ''
//           },
//           summary: {
//             netAmt: parseFloat(invoice.summary?.netAmt) || 0,
//             totalPaid: parseFloat(invoice.summary?.totalPaid) || 0,
//             adjAmt: parseFloat(invoice.summary?.adjAmt) || 0,
//             outstanding: parseFloat(invoice.summary?.outstanding) || 0
//           }
//         }));
//         setInvoicesData(invoicesRecords);
//       } else {
//         setInvoicesData([]);
//       }
//     });

//     return () => {
//       off(branchProfileRef);
//       off(suppliersRef);
//       off(invoicesRef);
//     };
//   };

//   const handleFilterChange = (key, value) => {
//     setFilters({ ...filters, [key]: value });
//   };

//   const handleGenerateReport = () => {
//     setShowReport(true);
//   };

//  const handlePrint = () => {
//   const printContent = (
//     <PurchaseOutstandingReportDisplay 
//       filters={filters}
//       branchProfile={branchProfile}
//       invoicesData={invoicesData}
//     />
//   );

//   const htmlString = ReactDOMServer.renderToString(printContent);

//   const printWindow = window.open('', '', 'width=1200,height=800');
//   printWindow.document.write(`
//     <html>
//       <head>
//         <title>Purchase Outstanding Report</title>
//         <style>
//           body { 
//             margin: 0; 
//             padding: 5px; 
//             font-family: Arial, sans-serif; 
//             font-size: 8px;
//           }
//           @page { 
//             size: A4 landscape; 
//             margin: 5mm; 
//           }
//           table { 
//             page-break-inside: auto;
//             width: 100%;
//             font-size: 7px;
//             table-layout: fixed;
//             border-collapse: collapse;
//           }
//           tr { 
//             page-break-inside: avoid; 
//             page-break-after: auto; 
//           }
//           th, td {
//                padding: 4px !important;
//             font-size: 12px !important;
//             white-space: nowrap;
//             overflow: hidden;
//             text-overflow: ellipsis;
//             max-width: 60px;
//           }
//           /* Specific column widths for better fit */
//           th:nth-child(1), td:nth-child(1) { width: 30px; } /* S.No */
//           th:nth-child(2), td:nth-child(2) { width: 80px; } /* Inv No */
//           th:nth-child(3), td:nth-child(3) { width: 60px; } /* Inv Dt */
//           th:nth-child(4), td:nth-child(4) { width: 80px; } /* Inv Amt */
//           th:nth-child(5), td:nth-child(5) { width: 80px; } /* Paid Amt */
//           th:nth-child(6), td:nth-child(6) { width: 80px; } /* Adj Amt */
//           th:nth-child(7), td:nth-child(7) { width: 80px; font-weight: bold; } /* Balance Amt */
//           .print-only {
//             width: 93% !important;
//             max-width: none !important;
//             overflow: visible !important;
//           }
//           div[style*="overflowX"] {
//             overflow: visible !important;
//           }
//         </style>
//       </head>
//       <body>
//         <div id="print-content">${htmlString}</div>
//         <script>
//           setTimeout(function() {
//             window.print();
//             window.close();
//           }, 1000);
//         </script>
//       </body>
//     </html>
//   `);
//   printWindow.document.close();
// };

//   if (loading) {
//     return (
//       <div style={{ 
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center', 
//         height: '400px',
//         fontSize: '18px',
//         color: '#64748b',
//         backgroundColor: '#f8fafc',
//         borderRadius: '12px',
//         border: '1px solid #e2e8f0'
//       }}>
//         <div style={{ textAlign: 'center' }}>
//           <div style={{ 
//             width: '40px', 
//             height: '40px', 
//             border: '4px solid #e2e8f0',
//             borderTop: '4px solid #3b82f6',
//             borderRadius: '50%',
//             animation: 'spin 1s linear infinite',
//             margin: '0 auto 16px'
//           }}></div>
//           <div>Loading Purchase Outstanding Data...</div>
//         </div>
//       </div>
//     );
//   }

//   if (!currentUser) {
//     return (
//       <div style={{ 
//         textAlign: 'center', 
//         padding: '3rem', 
//         color: '#64748b', 
//         fontSize: '18px',
//         backgroundColor: '#f8fafc',
//         borderRadius: '12px',
//         border: '1px solid #e2e8f0'
//       }}>
//         <h2 style={{ color: '#1e293b', marginBottom: '16px' }}>Authentication Required</h2>
//         <p>Please login to access the Purchase Outstanding Report </p>
//       </div>
//     );
//   }

//   return (
//     <div style={{
//       width: '100%',
//       maxWidth: '90rem',
//       backgroundColor: 'white',
//       borderRadius: '16px',
//       boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//       padding: '32px',
//       margin: '0 auto',
//       fontFamily: 'system-ui, -apple-system, sans-serif',
//       border: '1px solid #e2e8f0'
//     }}>
//       <style>
//         {`
//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}
//       </style>
      
//       <div style={{ 
//         display: 'flex', 
//         alignItems: 'center', 
//         gap: '12px',
//         marginBottom: '24px',
//         paddingBottom: '16px',
//         borderBottom: '2px solid #e2e8f0'
//       }}>
//         <div style={{
//           width: '6px',
//           height: '32px',
//           backgroundColor: '#3b82f6',
//           borderRadius: '3px'
//         }}></div>
//         <h1 style={{
//           fontSize: '28px',
//           fontWeight: '700',
//           color: '#1e293b',
//           margin: '0'
//         }}>Purchase Outstanding Report </h1>
//       </div>
      
//       {/* Filter Checkboxes */}
//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//         gap: '20px',
//         marginBottom: '32px',
//         whiteSpace: 'nowrap'
//       }}>
//         <FilterSection 
//           title="Branches" 
//           options={branches} 
//           selected={filters.branch} 
//           onChange={(value) => handleFilterChange("branch", value)}
//         />
//         <FilterSection 
//           title="Suppliers" 
//           options={suppliers} 
//           selected={filters.supplier} 
//           onChange={(value) => handleFilterChange("supplier", value)}
//         />
//       </div>

//       {/* Action Buttons */}
//       <div style={{ 
//         display: 'flex', 
//         gap: '16px', 
//         marginBottom: '32px',
//         justifyContent: 'center'
//       }}>
//         <button
//           onClick={handleGenerateReport}
//           style={{
//             background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
//             color: 'white',
//             padding: '12px 24px',
//             borderRadius: '8px',
//             border: 'none',
//             cursor: 'pointer',
//             transition: 'all 0.3s',
//             fontSize: '16px',
//             fontWeight: '600',
//             display: 'inline-flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             minWidth: '140px',
//             boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.transform = 'translateY(-2px)';
//             e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.transform = 'translateY(0)';
//             e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
//           }}
//         >
//           Generate Report
//         </button>
//         <button
//           onClick={handlePrint}
//           style={{
//             background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
//             color: 'white',
//             padding: '12px 24px',
//             borderRadius: '8px',
//             border: 'none',
//             cursor: 'pointer',
//             transition: 'all 0.3s',
//             fontSize: '16px',
//             fontWeight: '600',
//             display: 'inline-flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             minWidth: '120px',
//             boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.transform = 'translateY(-2px)';
//             e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.transform = 'translateY(0)';
//             e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
//           }}
//         >
//           Print Report
//         </button>
//       </div>

//       {/* Purchase Outstanding Report Display */}
//       {showReport && (
//         <PurchaseOutstandingReportDisplay 
//           filters={filters}
//           branchProfile={branchProfile}
//           invoicesData={invoicesData}
//         />
//       )}
//     </div>
//   );
// };

// export default PurchaseOutstandingReportGenerator;


import React, { useState, useEffect } from 'react';
import { database, auth } from '../firebase';
import { ref, onValue, off } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';
import ReactDOMServer from 'react-dom/server';

// Helper: Extract city from address
const getCityFromAddress = (address) => {
  if (!address) return 'Unknown City';
  const addressParts = address.trim().split(/\s+/);
  return addressParts.length > 0 ? addressParts[addressParts.length - 1] : 'Unknown City';
};

// Filter Section Component
const FilterSection = ({ title, options, selected, onChange }) => {
  const handleCheckboxChange = (option) => {
    if (option === options[0]) { // "All" option
      if (selected.includes(option)) {
        onChange([]);
      } else {
        onChange([...options]);
      }
    } else {
      const newSelected = selected.includes(option)
        ? selected.filter(item => item !== option && item !== options[0])
        : [...selected.filter(item => item !== options[0]), option];
      
      if (newSelected.length === options.length - 1) {
        onChange([options[0], ...newSelected]);
      } else {
        onChange(newSelected);
      }
    }
  };

  return (
    <div style={{
      backgroundColor: '#f8fafc',
      padding: '16px',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.3s ease',
      maxWidth: '220px',
      marginBottom: '16px',
    }}>
      <h2 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b',
        marginBottom: '8px',
        borderBottom: '2px solid #3b82f6',
        paddingBottom: '6px',
      }}>{title}</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {options.map((option) => (
          <label key={option} style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            cursor: 'pointer',
            padding: '6px',
            borderRadius: '6px',
            transition: 'background-color 0.2s',
            backgroundColor: selected.includes(option) ? '#eff6ff' : 'transparent',
          }}
          onMouseEnter={(e) => {
            if (!selected.includes(option)) {
              e.currentTarget.style.backgroundColor = '#f1f5f9';
            }
          }}
          onMouseLeave={(e) => {
            if (!selected.includes(option)) {
              e.currentTarget.style.backgroundColor = 'transparent';
            }
          }}
          >
            <input
              type="checkbox"
              checked={selected.includes(option)}
              onChange={() => handleCheckboxChange(option)}
              style={{
                height: '14px',
                width: '14px',
                accentColor: '#3b82f6',
                cursor: 'pointer',
              }}
            />
            <span style={{ 
              fontSize: '14px',
              color: '#475569',
              userSelect: 'none',
              fontWeight: selected.includes(option) ? '500' : '400',
            }}>{option}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

// Purchase Outstanding Report Display Component
const PurchaseOutstandingReportDisplay = ({ formData, filters, branchProfile, invoicesData }) => {
  const parseInvoiceDate = (dateString) => {
    if (!dateString) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return new Date(dateString);
    }
    if (/^\d{2}[-\/]\d{2}[-\/]\d{4}$/.test(dateString)) {
      const parts = dateString.split(/[-\/]/);
      return new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
    }
    return new Date(dateString);
  };

  const formatDisplayDate = (dateString) => {
    const date = parseInvoiceDate(dateString);
    return !date || isNaN(date.getTime()) ? 'N/A' : date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const filteredInvoicesData = invoicesData.filter(item => {
    const itemDate = parseInvoiceDate(item.supplierDetails?.invoiceDate);
    const fromDate = formData.fromDate ? new Date(formData.fromDate) : null;
    const toDate = formData.toDate ? new Date(formData.toDate) : null;
    toDate?.setHours(23, 59, 59, 999);

    let matchesFilters = true;
    if (fromDate) matchesFilters = matchesFilters && itemDate >= fromDate;
    if (toDate) matchesFilters = matchesFilters && itemDate <= toDate;
    if (filters.supplier.length > 0 && !filters.supplier.includes("All Suppliers")) {
      matchesFilters = matchesFilters && filters.supplier.includes(item.supplierDetails?.supplier || "Unknown Supplier");
    }
    if (filters.branch.length > 0 && !filters.branch.includes("All Branches")) {
      matchesFilters = matchesFilters && filters.branch.includes(branchProfile.branchName || "Unknown Branch");
    }
    return matchesFilters;
  });

  const totalInvoiceAmount = filteredInvoicesData.reduce((sum, item) => sum + (parseFloat(item.summary?.netAmt || 0)), 0);
  const totalPaidAmount = filteredInvoicesData.reduce((sum, item) => sum + (parseFloat(item.summary?.totalPaid || 0)), 0);
  const totalAdjAmount = filteredInvoicesData.reduce((sum, item) => sum + (parseFloat(item.summary?.adjAmt || 0)), 0);
  const totalBalanceAmount = filteredInvoicesData.reduce((sum, item) => sum + (parseFloat(item.summary?.netAmt || 0) - parseFloat(item.summary?.totalPaid || 0) - parseFloat(item.summary?.adjAmt || 0)), 0);

  const city = branchProfile.city || getCityFromAddress(branchProfile.address);

  return (
    <div style={{
      backgroundColor: 'white',
      padding: '30px',
      marginTop: '20px',
      border: '2px solid #3b82f6',
      borderRadius: '12px',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      pageBreakInside: 'avoid',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
    }} className="print-only">
      {/* Header */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start', 
        marginBottom: '30px',
        paddingBottom: '20px',
        borderBottom: '2px solid #e2e8f0'
      }}>
        <div style={{ flex: 1 }}>
          <h1 style={{ 
            fontSize: '24px', 
            fontWeight: 'bold', 
            margin: '0', 
            marginBottom: '15px',
            color: '#1e293b',
            textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
          }}>
            {branchProfile.branchName}
          </h1>
          <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#475569' }}>
            <div style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '600', color: '#3b82f6' }}>
              Purchase Outstanding Report
            </div>
            <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
              <span><strong>From:</strong> {formData.fromDate ? formatDisplayDate(formData.fromDate) : 'All'}</span>
              <span><strong>To:</strong> {formData.toDate ? formatDisplayDate(formData.toDate) : 'All'}</span>
            </div>
            <div style={{ marginTop: '8px' }}>
              <strong>Suppliers:</strong> {filters.supplier.includes("All Suppliers") ? "All Suppliers" : filters.supplier.join(", ")}
            </div>
          </div>
        </div>
        <div style={{
          background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
          color: 'white',
          padding: '15px 25px',
          borderRadius: '15px',
          textAlign: 'center',
          minWidth: '150px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{city}</div>
          <div style={{ fontSize: '12px', marginTop: '5px', opacity: '0.9' }}>
            {filters.branch.includes("All Branches") ? "All Branches" : filters.branch.join(", ")}
          </div>
        </div>
      </div>

      {/* Outstanding Table */}
      <div style={{ overflowX: 'auto' }}>
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse', 
          fontSize: '11px', 
          border: '2px solid #3b82f6',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Inv No</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Inv Dt</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Inv Amt</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Paid Amt</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Adj Amt</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Outstanding</th>
            </tr>
          </thead>
          <tbody>
            {filteredInvoicesData.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ 
                  border: '1px solid #cbd5e1', 
                  padding: '30px', 
                  textAlign: 'center', 
                  color: '#64748b', 
                  fontStyle: 'italic',
                  fontSize: '14px',
                  backgroundColor: '#f8fafc'
                }}>
                  No outstanding data found for the selected criteria
                </td>
              </tr>
            ) : (
              filteredInvoicesData.map((item, index) => {
                const balance = parseFloat(item.summary?.netAmt || 0) - 
                              parseFloat(item.summary?.totalPaid || 0) - 
                              parseFloat(item.summary?.adjAmt || 0);
                return (
                  <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.supplierDetails?.invoiceNo || 'N/A'}</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{formatDisplayDate(item.supplierDetails?.invoiceDate)}</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{parseFloat(item.summary?.netAmt || 0).toFixed(2)}</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{parseFloat(item.summary?.totalPaid || 0).toFixed(2)}</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{parseFloat(item.summary?.adjAmt || 0).toFixed(2)}</td>
                    <td style={{ 
                      border: '1px solid #cbd5e1', 
                      padding: '8px', 
                      textAlign: 'right', 
                      fontSize: '11px',
                      color: balance > 0 ? '#dc2626' : '#16a34a'
                    }}>₹{balance.toFixed(2)}</td>
                  </tr>
                );
              })
            )}
            
            {filteredInvoicesData.length > 0 && (
              <tr style={{ backgroundColor: '#fef3c7', fontWeight: 'bold', borderTop: '2px solid #f59e0b' }}>
                <td colSpan="3" style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'center', fontSize: '12px', fontWeight: '600' }}>
                  Grand Total
                </td>
                <td style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>₹{totalInvoiceAmount.toFixed(2)}</td>
                <td style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>₹{totalPaidAmount.toFixed(2)}</td>
                <td style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>₹{totalAdjAmount.toFixed(2)}</td>
                <td style={{ 
                  border: '1px solid #cbd5e1', 
                  padding: '10px', 
                  textAlign: 'right', 
                  fontSize: '12px', 
                  fontWeight: '600',
                  color: totalBalanceAmount > 0 ? '#dc2626' : '#16a34a'
                }}>₹{totalBalanceAmount.toFixed(2)}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Summary Section */}
      {filteredInvoicesData.length > 0 && (
        <div style={{ 
          marginTop: '30px', 
          padding: '20px', 
          backgroundColor: '#f8fafc', 
          borderRadius: '8px',
          border: '1px solid #e2e8f0'
        }}>
          <h3 style={{ 
            fontSize: '16px', 
            fontWeight: '600', 
            marginBottom: '15px',
            color: '#1e293b'
          }}>Summary</h3>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', 
            gap: '15px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Total Invoices</div>
              <div style={{ fontSize: '18px', fontWeight: '600', color: '#3b82f6' }}>{filteredInvoicesData.length}</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Total Invoice Amount</div>
              <div style={{ fontSize: '18px', fontWeight: '600', color: '#dc2626' }}>₹{totalInvoiceAmount.toFixed(2)}</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Total Paid Amount</div>
              <div style={{ fontSize: '18px', fontWeight: '600', color: '#059669' }}>₹{totalPaidAmount.toFixed(2)}</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Net Balance</div>
              <div style={{ fontSize: '18px', fontWeight: '600', color: '#7c3aed' }}>₹{totalBalanceAmount.toFixed(2)}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Main Purchase Outstanding Report Generator Component
const PurchaseOutstandingReportGenerator = () => {
  const today = new Date();
  const [fromDate, setFromDate] = useState(today.toISOString().split('T')[0]);
  const [toDate, setToDate] = useState(today.toISOString().split('T')[0]);
  const [filters, setFilters] = useState({
    branch: ["All Branches"],
    supplier: ["All Suppliers"]
  });
  const [branches, setBranches] = useState(["All Branches"]);
  const [suppliers, setSuppliers] = useState(["All Suppliers"]);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showReport, setShowReport] = useState(false);
  const [branchProfile, setBranchProfile] = useState({
    branchName: "SUPREME TRADERS",
    address: "",
    phone: "",
    city: ""
  });
  const [invoicesData, setInvoicesData] = useState([]);

  const encodeEmailForPath = (email) => {
    return email.replace(/[.#$[\]]/g, '_');
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      if (user) {
        loadFirebaseData(user);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const loadFirebaseData = (user) => {
    const encodedEmail = encodeEmailForPath(user.email);

    const branchProfileRef = ref(database, `users/${encodedEmail}/branchProfiles`);
    onValue(branchProfileRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const profiles = Object.values(data);
        const latestProfile = profiles[profiles.length - 1];
        setBranchProfile({
          branchName: latestProfile.branchName || "SUPREME TRADERS",
          address: `${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`.trim(),
          phone: latestProfile.mobileNo || '',
          city: latestProfile.city || getCityFromAddress(`${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`)
        });
        setBranches(["All Branches", latestProfile.branchName || "SUPREME TRADERS"]);
      }
    });

    const suppliersRef = ref(database, `users/${encodedEmail}/suppliers`);
    onValue(suppliersRef, (snapshot) => {
      const suppliersData = ["All Suppliers"];
      if (snapshot.exists()) {
        snapshot.forEach((childSnapshot) => {
          const supplier = childSnapshot.val();
          if (supplier.supplierName && !suppliersData.includes(supplier.supplierName)) {
            suppliersData.push(supplier.supplierName);
          }
        });
      }
      setSuppliers(suppliersData);
    });

    const invoicesRef = ref(database, `users/${encodedEmail}/invoices`);
    onValue(invoicesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const invoicesRecords = Object.entries(data).map(([id, invoice]) => ({
          id,
          supplierDetails: {
            supplier: invoice.supplierDetails?.supplier || 'Unknown Supplier',
            invoiceNo: invoice.supplierDetails?.invoiceNo || '',
            invoiceDate: invoice.supplierDetails?.invoiceDate || ''
          },
          summary: {
            netAmt: parseFloat(invoice.summary?.netAmt) || 0,
            totalPaid: parseFloat(invoice.summary?.totalPaid) || 0,
            adjAmt: parseFloat(invoice.summary?.adjAmt) || 0,
            outstanding: parseFloat(invoice.summary?.outstanding) || 0
          }
        }));
        setInvoicesData(invoicesRecords);
      } else {
        setInvoicesData([]);
      }
    });

    return () => {
      off(branchProfileRef);
      off(suppliersRef);
      off(invoicesRef);
    };
  };

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleGenerateReport = () => {
    setShowReport(true);
  };

  const handlePrint = () => {
    const printContent = (
      <PurchaseOutstandingReportDisplay 
        formData={{ fromDate, toDate }}
        filters={filters}
        branchProfile={branchProfile}
        invoicesData={invoicesData}
      />
    );

    const htmlString = ReactDOMServer.renderToString(printContent);

    const printWindow = window.open('', '', 'width=1200,height=800');
    printWindow.document.write(`
      <html>
        <head>
          <title>Purchase Outstanding Report</title>
          <style>
            body { 
              margin: 0; 
              padding: 5px; 
              font-family: Arial, sans-serif; 
              font-size: 8px;
            }
            @page { 
              size: A4 landscape; 
              margin: 5mm; 
            }
            table { 
              page-break-inside: auto;
              width: 100%;
              font-size: 7px;
              table-layout: fixed;
              border-collapse: collapse;
            }
            tr { 
              page-break-inside: avoid; 
              page-break-after: auto; 
            }
            th, td {
              padding: 4px !important;
              font-size: 12px !important;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 60px;
            }
            /* Specific column widths for better fit */
            th:nth-child(1), td:nth-child(1) { width: 30px; } /* S.No */
            th:nth-child(2), td:nth-child(2) { width: 80px; } /* Inv No */
            th:nth-child(3), td:nth-child(3) { width: 60px; } /* Inv Dt */
            th:nth-child(4), td:nth-child(4) { width: 80px; } /* Inv Amt */
            th:nth-child(5), td:nth-child(5) { width: 80px; } /* Paid Amt */
            th:nth-child(6), td:nth-child(6) { width: 80px; } /* Adj Amt */
            th:nth-child(7), td:nth-child(7) { width: 80px; font-weight: bold; } /* Balance Amt */
            .print-only {
              width: 93% !important;
              max-width: none !important;
              overflow: visible !important;
            }
            div[style*="overflowX"] {
              overflow: visible !important;
            }
          </style>
        </head>
        <body>
          <div id="print-content">${htmlString}</div>
          <script>
            setTimeout(function() {
              window.print();
              window.close();
            }, 1000);
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const formData = {
    fromDate,
    toDate
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '400px',
        fontSize: '18px',
        color: '#64748b',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '4px solid #e2e8f0',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <div>Loading Purchase Outstanding Data...</div>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '3rem', 
        color: '#64748b', 
        fontSize: '18px',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        <h2 style={{ color: '#1e293b', marginBottom: '16px' }}>Authentication Required</h2>
        <p>Please login to access the Purchase Outstanding Report </p>
      </div>
    );
  }

  return (
    <div style={{
      width: '100%',
      maxWidth: '90rem',
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      padding: '32px',
      margin: '0 auto',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      border: '1px solid #e2e8f0'
    }}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px',
        marginBottom: '24px',
        paddingBottom: '16px',
        borderBottom: '2px solid #e2e8f0'
      }}>
        <div style={{
          width: '6px',
          height: '32px',
          backgroundColor: '#3b82f6',
          borderRadius: '3px'
        }}></div>
        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#1e293b',
          margin: '0'
        }}>Purchase Outstanding Report </h1>
      </div>
      
      {/* Date Range and Search Filters */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '20px',
        marginBottom: '32px',
        padding: '24px',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        <div>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              transition: 'all 0.2s',
              boxSizing: 'border-box',
              backgroundColor: 'white'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
        <div>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              transition: 'all 0.2s',
              boxSizing: 'border-box',
              backgroundColor: 'white'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
      </div>

      {/* Filter Checkboxes */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '20px',
        marginBottom: '32px',
        whiteSpace: 'nowrap'
      }}>
        <FilterSection 
          title="Branches" 
          options={branches} 
          selected={filters.branch} 
          onChange={(value) => handleFilterChange("branch", value)}
        />
        <FilterSection 
          title="Suppliers" 
          options={suppliers} 
          selected={filters.supplier} 
          onChange={(value) => handleFilterChange("supplier", value)}
        />
      </div>

      {/* Action Buttons */}
      <div style={{ 
        display: 'flex', 
        gap: '16px', 
        marginBottom: '32px',
        justifyContent: 'center'
      }}>
        <button
          onClick={handleGenerateReport}
          style={{
            background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '16px',
            fontWeight: '600',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '140px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          }}
        >
          Generate Report
        </button>
        <button
          onClick={handlePrint}
          style={{
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '16px',
            fontWeight: '600',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '120px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          }}
        >
          Print Report
        </button>
      </div>

      {/* Purchase Outstanding Report Display */}
      {showReport && (
        <PurchaseOutstandingReportDisplay 
          formData={formData}
          filters={filters}
          branchProfile={branchProfile}
          invoicesData={invoicesData}
        />
      )}
    </div>
  );
};

export default PurchaseOutstandingReportGenerator;